import { Component, OnInit, Input, OnDestroy, NgZone } from '@angular/core';
import { Observable } from 'rxjs';
import { NotificationService } from '../../../shared/notification.service';
import {  MatSnackBar } from '@angular/material/snack-bar';
import { UserService } from '../../../../../core/user.service';
import { SidenavService } from '../../../../../shared/sidenav.service';
import { MsalService } from '@azure/msal-angular';

@Component({
  selector: 'app-contact-preference',
  templateUrl: './contact-preference.component.html',
  styleUrls: ['./contact-preference.component.scss']
})

export class ContactPreferenceComponent implements OnInit, OnDestroy {
  userEmail: string;
  tnumber: string;
  number: any;
  @Input() getAction: Observable<void>;
  eventsSubscription: any;

  constructor(
    private sidenav: SidenavService,
    private notSvc: NotificationService,
    private _snackBar: MatSnackBar,
    private userService: UserService,
    private ngZone: NgZone,
    private msalService : MsalService,
    private snackBar: MatSnackBar
  ) { }

  ngOnInit() {
    this.userEmail = this.msalService.instance.getAllAccounts()[0]?.username.toLocaleLowerCase();
    this.getUserContact();
    this.eventsSubscription = this.getAction.subscribe((action) => {
      this.setActions(action);
    })
  }

  async getUserContact() {
    this.notSvc.getUserContact(this.userEmail).subscribe((res) => {
      if (res && !res.message) {
        this.tnumber = `${res.PhoneCountryCode || ''} ${res.PhoneNumber || ''}`
      }
    }, ((error: any) => {
      if (error) {
        this.snackBar.open("Something went wrong. We're working on it and we'll get it fixed soon. Please try again later.", 'Close', {});
      }
    }));
  }

  setActions(type) {
    if (type === 'save') {
      this.save();
    } else if (type === 'reset') {
      this.tnumber = '';
    }
  }

  save() {
    if (this.tnumber.match(this.getPhoneRegex())) {
      this.number = this.tnumber.split(/(\s+)/);
      const payload = {
        email: this.userEmail,
        PhoneCountryCode: this.number[0] || null,
        PhoneNumber: this.number[2] || null
      };
      this.saveContact(payload);
    } else {
      this.ngZone.run(() => {
        // this._snackBar.open(`${this.tnumber} saved successfully`, 'Close', {});
        this._snackBar.open('Country code and Phone Number is not in right format.', 'Close', {duration: 5000});
      });
    }
  }

  getPhoneRegex() {
    return /^$|^(\d{1,3}[\s])(\d{1,15})/;
  }

  saveContact(payload) {
    this.notSvc.updateUserContact(payload).subscribe((res) => {
      this.ngZone.run(() => {
        this._snackBar.open(`${this.tnumber} saved successfully`, 'Close', {duration: 1000});
      });
    }, err => {
      this.ngZone.run(() => {
        this._snackBar.open(`Unable to update ${this.tnumber}`, 'Close', {});
      });
    });
  }

  checkNumber(event) {
    let value = event.target.value || '';
    value = value.replace(/[^0-9 ]/, '');
    event.target.value = value;
  }

  ngOnDestroy() {
    this.eventsSubscription.unsubscribe();
  }
}
